import {Injectable} from '@angular/core';
import {Http, RequestOptions, Response, Headers} from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import {Observable} from "rxjs/Observable";
import 'rxjs/add/operator/catch';

@Injectable()
export class CommonService {
    urlLink: string;
    myData: string;
    loading: any;
    auditInfo: any;
    masterApi : any;
    is_loggedin : boolean = false;
    dataChange: Observable<any>;
    constructor(public http: Http) {

    }

    post_data(postdata, url) {
        //this.loading.present();
        this.myData = JSON.stringify(postdata);
        let headers = new Headers({'Content-Type': 'application/json'});
        let options = new RequestOptions({headers: headers});
        return this.http.post(url, postdata, options).map(
            res => {
                return res.json();
            }
        ).catch((e: Response | any) => {
            //this.loading.dismiss();
            let errorObj = e._body;
            return Observable.throw(JSON.parse(errorObj));
        });
    }

    get_data(url, show_loader = true) {
        //let user = this.getUserInfo();
        let headers = new Headers({'Content-Type': 'application/json'});
        let options = new RequestOptions({headers: headers});
        //headers.append('Authorization', 'Bearer ' + user.token)
        return this.http.get(url, options).map(
            result => {
                return result.json();
            }
        ).catch((e: Response | any) => {
            let errorObj = e._body;
            return Observable.throw(JSON.parse(errorObj));
        });
    }


    private catchError(error: Response | any) {
        return error.json();
    }

    setAuditInfo(data) {
        this.auditInfo = data;
    }

    getAuditInfo() {
        return this.auditInfo;
    }

    setLoggedIn(status){
        this.is_loggedin = status;
    }

    getLgoggedIn(){
        return this.is_loggedin;
    }
    setMasterApi(data) {
        this.masterApi = data;
    }

    getMasterApi() {
        return this.masterApi;
    }

}



// WEBPACK FOOTER //
// /var/www/illumine/desktop/src/app/common.service.ts